/* The curl. A square button (a human action) curls into a white ball (the cat's world)
   while something happens, then settles or opens back up. Used only on commitment buttons. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.8,.3,1)', WHITE = '#FFFFFF';
  function state(btn) {
    if (btn._curl) return btn._curl;
    var cs = getComputedStyle(btn), w = btn.offsetWidth, h = btn.offsetHeight;
    var hold = document.createElement('span');
    hold.className = 'curl-hold';
    hold.style.width = w + 'px'; hold.style.height = h + 'px';
    btn.parentNode.insertBefore(hold, btn); hold.appendChild(btn);
    return (btn._curl = { w: w, h: h, ink: cs.backgroundColor, text: cs.color, hold: hold,
      ring: 'inset 0 0 0 1.5px ' + cs.backgroundColor, none: 'inset 0 0 0 0px ' + cs.backgroundColor, breathe: null });
  }
  function ball(btn, s) {
    btn.style.width = s.h + 'px'; btn.style.padding = '0'; btn.style.borderRadius = '50%';
    btn.style.background = WHITE; btn.style.boxShadow = s.ring; btn.style.color = 'transparent';
  }
  function start(btn) {
    var s = state(btn);
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-label', 'Sending');
    if (reduce || !btn.animate) { ball(btn, s); return Promise.resolve(); }
    var a0 = btn.animate([{ transform: 'scale(1,1)', color: s.text }, { transform: 'scale(1,.84)', color: 'transparent' }], { duration: 90, easing: 'ease-out', fill: 'forwards' });
    return (s.starting = a0.finished.then(function () {
      btn.style.color = 'transparent'; btn.style.padding = '0';
      var h = s.h, a = btn.animate([
        { width: s.w + 'px', borderRadius: '0px', transform: 'scale(1,.84)', backgroundColor: s.ink, boxShadow: s.none },
        { width: (h * .92) + 'px', borderRadius: (h / 2) + 'px', transform: 'scale(.86,1.16)', backgroundColor: WHITE, boxShadow: s.ring, offset: .5 },
        { width: h + 'px', borderRadius: (h / 2) + 'px', transform: 'scale(1.16,.88)', backgroundColor: WHITE, boxShadow: s.ring, offset: .72 },
        { width: h + 'px', borderRadius: (h / 2) + 'px', transform: 'scale(.96,1.04)', backgroundColor: WHITE, boxShadow: s.ring, offset: .88 },
        { width: h + 'px', borderRadius: (h / 2) + 'px', transform: 'scale(1,1)', backgroundColor: WHITE, boxShadow: s.ring }
      ], { duration: 560, easing: EASE, fill: 'forwards' });
      a0.cancel();
      return a.finished.then(function () { ball(btn, s); a.cancel(); });
    }).then(function () {
      s.breathe = btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.1,1.06)' }], { duration: 1100, direction: 'alternate', iterations: Infinity, easing: 'ease-in-out' });
    }));
  }
  /* success and failure always wait for the curl to finish, however fast the reply comes back */
  function after(btn, fn) { var s = state(btn); return (s.starting || Promise.resolve()).then(function () { return fn(s); }); }
  function success(btn) { return after(btn, function (s) {
    if (s.breathe) s.breathe.cancel();
    if (reduce || !btn.animate) return;
    return btn.animate([
      { transform: 'translateY(0) scale(1)' }, { transform: 'translateY(-14px) scale(.9,1.1)', offset: .35 },
      { transform: 'translateY(0) scale(1.2,.75)', offset: .7 }, { transform: 'translateY(0) scale(.23)' }
    ], { duration: 420, easing: 'cubic-bezier(.3,.7,.4,1)', fill: 'forwards' }).finished;
  }); }
  function restore(btn, s) {
    ['width', 'padding', 'borderRadius', 'background', 'boxShadow', 'color'].forEach(function (k) { btn.style[k] = ''; });
    btn.disabled = false; btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-label');
  }
  function fail(btn) { return after(btn, function (s) {
    if (s.breathe) s.breathe.cancel();
    if (reduce || !btn.animate) { restore(btn, s); return; }
    return btn.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(0)' }], { duration: 260, easing: 'ease-out' }).finished
      .then(function () {
        return btn.animate([
          { width: s.h + 'px', borderRadius: (s.h / 2) + 'px', backgroundColor: WHITE, boxShadow: s.ring },
          { width: (s.w * 1.04) + 'px', borderRadius: '0px', backgroundColor: s.ink, boxShadow: s.none, offset: .7 },
          { width: s.w + 'px', borderRadius: '0px', backgroundColor: s.ink, boxShadow: s.none }
        ], { duration: 380, easing: EASE }).finished;
      }).then(function () { restore(btn, s); });
  }); }
  window.PFCurl = { start: start, success: success, fail: fail };

  /* Waitlist forms post to Shopify and reload the page: curl, then send. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.wl') || form._curling) return;
    var btn = form.querySelector('button[type=submit]');
    if (!btn) return;
    if (form.checkValidity && !form.checkValidity()) return; // let the browser show its message
    e.preventDefault(); form._curling = true;
    start(btn).then(function () { if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form); });
  });
})();
